export default __webpack_public_path__ + "static/media/About-products.489a784a.svg";